import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { ScheduleType } from 'mbs-ui-shared@models/schedule-type.enum';
import { WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { PlanDataFromStepsHelper } from 'wizards/helpers/plan-data-from-steps-helper/plan-data-from-steps-helper';
import { RestorePlanFromStepsHelper } from 'wizards/helpers/restore-plan-from-steps-helper/restore-plan-from-steps-helper';
import { BaseForPlanHelper } from 'wizards/models/base/base-models/base-for-plan-helper';
import { RestoreDatabaseFormModel } from 'wizards/models/databaseRestore/restore-database-form-model';

export class RestoreDatabasePlanFromStepsHelpers extends BaseForPlanHelper {
  public static RestoreDBModel: RestoreDatabaseFormModel;

  public static getUpdatedPlan(plan, model: RestoreDatabaseFormModel, settings: WizardHelpersSettings): any {
    this.RestoreDBModel = model;
    this.updateSchedules(
      +ScheduleType[model.scheduleStep.ScheduleType] === ScheduleType.recurring,
      this.RestoreDBModel.scheduleAdvancedStep
    );
    const newPlan = Object.assign({}, plan);
    this.updateModel(newPlan, settings);
    return newPlan;
  }

  static updateModel(newPlan, settings: WizardHelpersSettings): void {
    RestorePlanFromStepsHelper.updateNewPlanByNameStep(newPlan, this.RestoreDBModel.planNameStep);
    PlanDataFromStepsHelper.updateNewPlanByWhereBackupStep(newPlan, this.RestoreDBModel.whereBackupStep);
    RestorePlanFromStepsHelper.updateNewPlanByBackupToRestoreStep(newPlan, this.RestoreDBModel.backupToRestoreStep);
    this.setDataFromRestore(newPlan, settings, this.RestoreDBModel);
    RestorePlanFromStepsHelper.updateNewPlanByRestorePointDBStep(newPlan, this.RestoreDBModel.restorePointStep, settings.timeZoneOffset);

    if (settings.planType === PlanTypes.RestoreDataBasePlan) {
      PlanDataFromStepsHelper.updateNewPlanBySQLServerInstance(newPlan, this.RestoreDBModel.sqlServerInstanceStep, true);
    }

    RestorePlanFromStepsHelper.updateRestoreSourceDB(newPlan, this.RestoreDBModel.restoreSourceStep, settings.isUnix);

    if (settings.planType === PlanTypes.RestoreDataBasePlan) {
      PlanDataFromStepsHelper.updateNewPlanBySQLServerInstance(newPlan, this.RestoreDBModel.sqlServerInstanceStep);
      RestorePlanFromStepsHelper.updateRestoreDestinationDB(newPlan, this.RestoreDBModel.destinationStep);
    } else RestorePlanFromStepsHelper.updateRestoreDestinationFileDB(newPlan, this.RestoreDBModel.destinationStep);

    RestorePlanFromStepsHelper.updateNewPlanByEncryptionOptionsStep(newPlan, this.RestoreDBModel.encryptionOptionsStep);
    RestorePlanFromStepsHelper.updateNewPlanByScheduleStep(
      newPlan,
      this.RestoreDBModel.scheduleStep,
      this.RestoreDBModel.scheduleAdvancedStep,
      settings.isUnix,
      settings.isNBF
    );
    PlanDataFromStepsHelper.updateNewPlanByPrePostActionsStep(
      newPlan,
      this.RestoreDBModel.prePostActionsStep,
      !settings.allowPrePostActions,
      false,
      true
    );
    PlanDataFromStepsHelper.updateNewPlanByNotificationStep(newPlan, this.RestoreDBModel.notificationStep);
    PlanDataFromStepsHelper.preparePlanForSending(newPlan);
  }
}
